<template>
    <p><strong>PRIVACY POLICY<br><br></strong></p>
    <p>Bat Norton Co.,Ltd.<br><br></p>
    <p>Legal entity number 0815565002608<br><br></p>
    <p>Address:</p>
    <p>339/17 Soi Wachiratham Sathit 15, Sukhumvit Road 101/1, Bang Chak Sub-district, Phra Khanong District, Bangkok,
        Thailand 10260.</p>
    <p><br></p>
    <p><a href="tel:082-5851554" class="article__link">Tel: +66 82-5851554</a><br><br></p>
    <p>{{ trans("Privacy policy") }} ({{trans("hereinafter")}} - {{trans("policy")}}) {{trans("applies to all information that the company may obtain about a visitor to the")}} <router-link to="/">batnorton.com</router-link> {{trans("website")}} ({{trans("hereinafter")}} - {{trans("site")}})</p>
    <p>{{trans("text-20")}} ({{trans("hereinafter")}} - {{trans("legislation")}}).</p>
    <p>{{trans("The information on the site is of an informative nature, and any changes may be made without prior notice")}}.<br><br><br></p>
    <p><strong>{{trans("User's personal information and its security")}}<br><br></strong></p>
    <p>{{trans("Personal information of the user means")}}:</p>
    <p>{{trans("text-21")}}.</p>
    <p>{{trans("text-22")}}.</p>
    <p>{{trans('text-23')}}.</p>
    <p>{{trans("text-24")}}.</p>
    <p>{{trans("The user's personal information is kept confidential")}}.</p>
    <p>{{trans("text-25")}}.<br><br><br>
    </p>
    <p><strong>{{trans("General Provisions")}}<br><br></strong></p>
    <p>{{trans("t-1")}}.</p>
    <p>{{trans("t-2")}}.</p>
    <p>{{trans("t-3")}}.</p>
    <p>{{trans("t-4")}}.</p>
    <p>{{trans("t-5")}}.<br><br><br></p>
    <p><strong>{{trans("Purposes of processing personal information")}}<br><br></strong></p>
    <p>{{trans("The site processes user's personal information for the following purposes")}}:</p>
    <p>{{trans("identification of the user and providing him/her with a personal account on the site")}};</p>
    <p>{{trans("t-6")}}.</p>
    <p>{{trans("improving the quality of the site, its usability, development of new services and facilities")}};</p>
    <p>{{trans("targeted selection of advertising materials")}};</p>
    <p>{{trans("conducting statistical and other studies based on anonymized data")}}.<br><br><br></p>
    <p><strong>{{trans("The Company processes personal data in the following ways")}}:<br><br></strong></p>
    <p>{{trans("non-automated processing")}} ({{trans("on paper")}});</p>
    <p>{{trans("automated processing")}};</p>
    <p>{{trans("mixed processing")}}.</p>
    <p>{{trans("t-7")}}.</p>
    <p>{{trans('t-8')}}.</p>
    <p>{{trans("t-9")}}.</p>
    <p>{{trans("When processing personal data, the company is guided by the principles")}}:</p>
    <p>{{trans("legality of the purposes and methods of their processing, good faith")}};</p>
    <p>{{trans("t10")}};</p>
    <p>{{trans("t11")}};</p>
    <p>{{trans("t12")}};</p>
    <p>{{trans("t13")}};</p>
    <p>{{trans("t14")}};</p>
    <p>{{trans("t15")}};</p>
    <p>{{trans("t16")}};</p>
    <p>{{trans("t17")}};</p>


    <p>{{trans("at the user's request")}}.</p>
    <p>{{trans("t18")}}.</p>
    <p>{{trans("Modification and deletion of personal information, data storage")}}.</p><br>
    <p>{{trans("t19")}}.</p>
    <p>{{trans("t20")}}.</p>

    <p>{{trans("t21")}}.</p>
    <p>{{trans("Email newsletters and anti-spam")}}</p>
    <p>{{trans("t22")}}.</p>
    <p>{{trans("When a user makes a purchase on the site, a confirmation is sent to his personal e-mail")}}.</p>
    <p>{{trans("t23")}}.</p>
    <p>{{trans("t24")}}.</p>
    <p>{{trans("t25")}}.</p>


    <p>{{trans("The Company guarantees that the user's personal e-mail will not be used for sending spam")}}.<br><br><br></p>
    <p><strong>{{trans("Final provisions")}}<br><br></strong></p>
    <p>{{trans("t26")}}.</p>
    <p>{{trans('t27')}}.</p>
    <p>{{trans("t28")}}.</p>
    <p>{{trans("Feedback. Questions and suggestions")}}</p>
    <p>{{trans("Any suggestions or questions regarding this policy and the operation of the website may be sent to")}}
        info@batnorton.com.</p>

</template>

<script>
export default {}
</script>

<style scoped>

</style>
